if (!customElements.get('product-images-thumbnails')) {
  customElements.define('product-images-thumbnails', class productImagesThumbnails extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = this._getElements();
      this._setupEventListeners();
    }

    _getElements() {
      return {
       thumbnails: this.querySelector('.product-images-thumbnails'),
      }
    }

    _isMobile() {
      return window.innerWidth < 750;
    }

    setHeight() {
      if(this.dataset.carouselType === 'vertical' && !this._isMobile()) {
        const heightElement = document.querySelector(this.dataset.elementId);
        this.elements.thumbnails.style.height = heightElement.offsetHeight + 'px';
      }
    }

    _setThumbnailsActive(slideIndex) {
      this.querySelector('.product-images-thumbnails-item-active') && this.querySelector('.product-images-thumbnails-item-active').classList.remove('product-images-thumbnails-item-active');
      let isFirstItem = slideIndex == 1;
      isFirstItem
        ? this.elements.thumbnails.children[0].classList.add('product-images-thumbnails-item-active')
        : this.elements.thumbnails.children[slideIndex - 1] && this.elements.thumbnails.children[slideIndex - 1].classList.add('product-images-thumbnails-item-active');
    }
    
    _onThumbnailsItemClick(thumbnailsItem) {
      if(thumbnailsItem.classList.contains('product-images-thumbnails-item-active')) return;

      const thumbnailsId = thumbnailsItem.dataset.id;
      this.dispatchEvent(new CustomEvent('slideChanged', {
        bubbles: true,
        detail: {
          slideId: thumbnailsId,
        }
      }));
    }

    slideTo(slideIndex, smooth) {
      let slideSize = 0;
      const offset = 10;
      const isMobile = this._isMobile();
      let horizontalCarouselType = this.dataset.carouselType === 'horizontal';
      if(horizontalCarouselType || isMobile) {
        slideSize = this.elements.thumbnails.children[0].children[0].offsetWidth;
      } else {
        slideSize = this.elements.thumbnails.children[0].children[0].offsetHeight; 
      }
      const newPosition = (slideIndex - 1) * (slideSize + offset)
      this.elements.thumbnails.scrollTo({
        top: !(this.dataset.carouselType === 'horizontal') || !isMobile ? newPosition : 0,
        left: (this.dataset.carouselType === 'horizontal') || isMobile ? newPosition : 0,
        behavior: smooth ? "smooth" : "instant",
      });
      this._setThumbnailsActive(slideIndex);
    }

    _setupEventListeners() {
      this.addEventListener('click', (event) => {
        let thumbnailsItem = event.target.closest('.product-images-thumbnails-item');
        if(thumbnailsItem) {
          this._onThumbnailsItemClick(thumbnailsItem);
        }
      });

      window.addEventListener('load', () => {
        this.setHeight();
        this.elements.thumbnails.classList.remove('hidden');
      }, { once: true });
    }
  });
}
